import { aosConfiguration } from "./config/aos.ts";
import { animationIsRequired, animationItemProcessor } from "./utils.ts";
import { consoleString } from "../utils";


const setupAOS = async () => {
  console.time('✅ animate on scroll library scripts loaded in')
  await import("aos")
    .then((AOS) => {
      console.timeEnd('✅ animate on scroll library scripts loaded in')
      animationItemProcessor(aosConfiguration)
      AOS.default.init({
        duration: 1000,
        mirror: false,
        once: true,
      })
    })
    .catch((err) => {
      console.log(
        `%c❌ an error occurred while loading the animate on scroll library\n`,
        consoleString.error,
        err
      );
    });
}

const initAOS = () => {
  if (animationIsRequired(aosConfiguration)) setupAOS();
}

export {
  initAOS
}
